import axiosNewApi from "../config/axiosNewApi";

export const userMachines = async (machineTerm, machineType, signal) => {
  if (!machineTerm || machineTerm === "") {
    return;
  }
  return await axiosNewApi.get(
    `mobile/machines/${machineTerm ?? ""}?type=${machineType ?? ""}`,
    {
      withCredentials: true,
      signal,
    }
  );
};

export const guestMachines = async (machineTerm, machineType, signal) => {
  return await axiosNewApi.get(
    `mobile/machines/guest/${machineTerm ?? ""}?type=${machineType ?? ""}`,
    {
      signal,
    }
  );
};
